document.querySelectorAll( '.b-getresponse' ).forEach( ( block ) => {

	const loader = block.querySelector( '[data-loader]' );
	const formContainer = block.querySelector( '.b-getresponse__form-container' );
	const form = formContainer ? formContainer.querySelector( 'getresponse-form, [data-gr-live]' ) : null;

	if ( ! loader || ! form ) {

		return;

	}

	/**
	 * Hide the loader once the GetResponse form is fully loaded.
	 */
	const hideLoader = () => {

		loader.classList.add( 'is-hidden' );
		loader.setAttribute( 'aria-hidden', 'true' );

	};

	// Check if GetResponse is loaded

	// Wait for GetResponse to load
	const observer = new MutationObserver( () => {

		// Check for data-ready attribute on getresponse-form
		if ( form.hasAttribute( 'data-ready' ) || form.querySelector( 'iframe' ) ) {

			hideLoader();
			observer.disconnect();

		}

	} );

	observer.observe( form, {
		attributes: true,
		attributeFilter: [ 'data-ready' ],
		childList: true,
		subtree: true
	} );

} );
